import { useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useWebSocket } from './use-web-socket';
import { safeLocalStorage } from 'src/utils/local-storage';
import { START_RECORDING_SENT_KEY_PREFIX } from 'src/utils/pvo';

const getMessageHash = (message: any): string | null => {
  if (!message) return null;

  if (typeof message.payload === 'string') {
    return message.payload;
  }

  if (message.payload?.hash) {
    return message.payload.hash;
  }

  return null;
};

const wasSelfStartRecording = (hash: string): boolean => {
  const marker = safeLocalStorage.getItem(
    `${START_RECORDING_SENT_KEY_PREFIX}${hash}`
  );
  return Boolean(marker);
};

export const useStartRecordingStatus = () => {
  const { hash } = useParams();
  const navigate = useNavigate();
  const { isConnected, subscribe, unsubscribe } = useWebSocket();

  const handleSocketMessage = useCallback(
    (message: any) => {
      if (!hash) return;

      const messageHash = getMessageHash(message);
      if (messageHash !== hash) return;

      if (wasSelfStartRecording(hash)) {
        return;
      }

      navigate('/hash-used');
    },
    [hash, navigate]
  );

  useEffect(() => {
    if (!isConnected || !hash) {
      return;
    }

    const channel = 'pvo.start_recording';
    subscribe(channel, handleSocketMessage);

    return () => {
      unsubscribe(channel);
    };
  }, [isConnected, hash, subscribe, unsubscribe, handleSocketMessage]);
};
